import { createContext } from 'react';

const SpreedlyCVVDialogContext = createContext();

export default SpreedlyCVVDialogContext;
